import { CurrencyPipe } from '@angular/common';

import { EnderecoImovelPipe } from '../pipes/endereco-imovel.pipe';
import { ImovelResponseDto } from '../dto/imovel-response.dto';
import { BuscaAvancadaFilter } from '../model/busca-avancada-filter.model';

export function resetBuscaAvancadaFilter(): BuscaAvancadaFilter {
   return {
      contrato: undefined,
      cidade: undefined,
      tipo: undefined,
      subtipo: undefined,
      status: undefined,
      'quarto.gte': undefined,
      'quarto.lte': undefined,
      'banheiro.gte': undefined,
      'banheiro.lte': undefined,
      'garagem.gte': undefined,
      'garagem.lte': undefined,
      'aluguel.gte': undefined,
      'aluguel.lte': undefined,
      'compra.gte': undefined,
      'compra.lte': undefined,
      'area.gte': undefined,
      'area.lte': undefined,
      suites: undefined,
      quartos: undefined,
      enderecoRef: undefined,
      comodidades: undefined,
      financiavel: undefined,
      bairros: undefined,
      tags: undefined,
      video: undefined,
      sortby: undefined,
      lat: undefined,
      long: undefined,
      radius: undefined,
      page: undefined,
      pageSize: undefined,
      id_condominio: undefined,
      mobilia: undefined,
      situacao: undefined,
      condicao: undefined,
      permuta: undefined,
      keywords: undefined,
      codigos: undefined
   };
}

export function buildMapCardHTML(imovel: ImovelResponseDto): string {
   const enderecoImovelPipe =  new EnderecoImovelPipe();
   const currencyPipe = new CurrencyPipe('pt-BR');

   const imgSrc = imovel.imagens && imovel.imagens.length > 0 ? imovel.imagens[0].link_thumb : '';
   const endereco = enderecoImovelPipe.transform(imovel);

   let valor = '';
   if (imovel.valor_venda) {
      valor = currencyPipe.transform(imovel.valor_venda, 'BRL');
   } else if (imovel.valor_locacao) {
      valor = currencyPipe.transform(imovel.valor_locacao, 'BRL') + '/mês';
   }

   const areaPrincipal = imovel.area_privativa;
   const quartos = imovel.dormitorios;
   const garagens = imovel.garagens;
   const banheiros = imovel.banheiros;

   return `<button id="btn-fechar-info" class="btn-fechar" style="display: flex; width: 96%; justify-content: end; margin-bottom: -25px;">
            <i class="fa-solid fa-x fa-flip-both" 
            style="color: red; background: #fff; padding: 10px; border-radius: 60%;
            margin-top: -20px; margin-right: -35px; width: 35px; height: 35px;"></i>
          </button>
          <div class="mini-card">
            <div style="cursor:pointer">
            </div>
            <div click="abreImovel(${imovel.codigo})">
              <div>
                <div>
                  <img src="${imgSrc}" alt="Imagem" 
                  style="width: 100%;
                  height: 30vh;
                  object-fit: cover;
                  border-radius: 7px;">
                </div>
              </div>
              <div style="body-card">
              <p style="display: flex; justify-content: space-between; margin:0!important;"><span><b>${imovel.subtipo}</b></span><span style="font-size: 13px;">(${imovel.codigo})</span></p>
                <p style="margin:0!important;">${endereco}</p>
                <div style="display: flex; justify-content: space-between; align-items: baseline; letter-spacing: -0.3px; position: relative; bottom:0;">
                  <p style="
                  width: 45%;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 1.2;
                  height: 1.6rem;
                  font-weight: 700;
                  font-size: 17px;
                  color: #ff0400;
                  letter-spacing: -1.2px;
                  margin: 0;">
                    ${valor}
                  </p> 
                  <div style="
                  display: flex;
                  font-weight: 400;
                  justify-content: space-between;
                  font-size: 12px;
                  align-items: flex-end;
                  color: #000000;
                  margin: 4px 0 4px 4px;
                  letter-spacing: 1px;
                  margin: 0;">
                    <p>
                      <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
                      <b>${areaPrincipal} m²</b>
                    </p>
                    <p>
                      <i class="fa-solid fa-bed"></i>
                      <b>${quartos}</b>
                    </p>
                    <p>
                      <i class="fa-solid fa-shower"></i>
                      <b>${banheiros}</b>
                    </p>
                    <p>
                      <i class="fa-solid fa-car"></i>
                      <b>${garagens}</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>`;
}
